// Contact.jsx
import React, { useEffect, useState } from "react";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import { wp } from "../lib/wp";

const Contact = () => {
  const [contactData, setContactData] = useState(null);

  useEffect(() => {
    fetch(wp("/wp/v2/pages?slug=contact"))
      .then((res) => res.json())
      .then((data) => setContactData(data[0]));
  }, []);

  if (!contactData) return <div className="p-6">Yükleniyor...</div>;

  return (
    <div className="max-w-5xl mx-auto px-6 py-12 bg-[#F8F6ED] text-gray-800">
      {/* Başlık */}
      {/* <h2 className="text-3xl font-bold justify-center text-center mb-8 text-[#27285C]"> */}

      <h2 className="text-3xl font-bold justify-center text-center mb-8 text-[#403f95]">
        İLETİŞİM
      </h2>

      {/* Bilgi Kartları */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 text-sm">
        {/* Adres */}
        <div
          className={[
            "bg-[#F8F6ED] rounded-xl p-6 flex items-start space-x-4",
            "border border-[0.5px] border-[#424197]",
            "shadow-[0_6px_15px_rgba(39,40,92,0.15),0_1px_3px_rgba(39,40,92,0.10)]",
            "hover:shadow-[0_16px_40px_rgba(39,40,92,0.25),0_4px_10px_rgba(39,40,92,0.15)]",
            "transition-all duration-300 ease-out",
          ].join(" ")}
        >
          <FiMapPin className="text-4xl mt-1 text-gray-800" />
          <div>
            <h2 className="font-semibold mb-1 underline">Adres</h2>
            <p>{contactData.contact_address}</p>
          </div>
        </div>

        {/* Telefon */}
        <div
          className={[
            "bg-[#F8F6ED] rounded-xl p-6 flex items-start space-x-4",
            "border border-[0.5px] border-[#424197]",
            "shadow-[0_6px_15px_rgba(39,40,92,0.15),0_1px_3px_rgba(39,40,92,0.10)]",
            "hover:shadow-[0_16px_40px_rgba(39,40,92,0.25),0_4px_10px_rgba(39,40,92,0.15)]",
            "transition-all duration-300 ease-out",
          ].join(" ")}
        >
          <FiPhone className="text-2xl mt-1 text-gray-800" />
          <div>
            <h2 className="font-semibold mb-1 underline">Telefon</h2>
            <a
              href={`tel:${contactData.contact_phone}`}
              className="relative inline-block text-gray-800 transition-colors duration-300 hover:text-[#27285C]
                         after:content-[''] after:absolute after:left-0 after:-bottom-0.5 after:h-[2px]
                         after:w-0 after:bg-[#27285C] after:transition-all after:duration-500 hover:after:w-full"
            >
              {contactData.contact_phone}
            </a>
          </div>
        </div>

        {/* E-posta */}
        <div
          className={[
            "bg-[#F8F6ED] rounded-xl p-6 flex items-start space-x-4",
            "border border-[0.5px] border-[#424197]",
            "shadow-[0_6px_15px_rgba(39,40,92,0.15),0_1px_3px_rgba(39,40,92,0.10)]",
            "hover:shadow-[0_16px_40px_rgba(39,40,92,0.25),0_4px_10px_rgba(39,40,92,0.15)]",
            "transition-all duration-300 ease-out",
          ].join(" ")}
        >
          <FiMail className="text-2xl mt-1 text-gray-800" />
          <div>
            <h2 className="font-semibold mb-1 underline">E-posta</h2>
            <a
              href={`mailto:${contactData.contact_email}`}
              className="relative inline-block text-gray-800 transition-colors duration-300 hover:text-[#27285C]
                         after:content-[''] after:absolute after:left-0 after:-bottom-0.5 after:h-[2px]
                         after:w-0 after:bg-[#27285C] after:transition-all after:duration-500 hover:after:w-full"
            >
              {contactData.contact_email}
            </a>
          </div>
        </div>
      </div>

      {/* Harita – border yok */}
      {contactData.contact_map_embed && (
        <div className="rounded-lg overflow-hidden shadow-lg w-full">
          <div
            className="w-full"
            dangerouslySetInnerHTML={{ __html: contactData.contact_map_embed }}
          />
        </div>
      )}
    </div>
  );
};

export default Contact;
